<template>
    <div class="modal">
        <div class="modal-box">
            <div class="close" @click="$emit('close')">
                <span>X</span>
            </div>
            <div class="modal-body">
                <div class="form-box" v-if="!confirmed">
                    <div>
                        <h1>Insira seu e-mail para recuperar sua senha.</h1>
                        <p>
                            Em seguida você receberá um e-mail contendo um link para inserir sua nova senha.
                        </p>
                    </div>
                    <form @submit="handleSubmit">
                        <div class="input-box">
                            <label for="email">E-mail *</label>
                            <input
                            type="text"
                            name="email"
                            id="email"
                            v-model="form.email"/>
                            <small class="error" v-if="errors && errors.email">{{errors.email.join()}}</small>
                        </div>
                        <div class="form-actions" v-if="!confirmed">
                            <button v-if="!loading" class="button btn-primary">
                                Recuperar
                            </button>
                            <button v-if="loading" class="button btn-primary" disabled>
                                <loading />
                            </button>
                        </div>
                        <div class="form-actions" v-if="confirmed">
                            <p>Foi enviado para o seu e-mail um link para redefinir sua senha.</p>
                        </div>
                    </form>
                </div>
                <div class="form-box" v-if="confirmed">
                    <div>
                        <h1>Confirmado!</h1>
                        <p>Foi enviado para o seu e-mail um link para redefinir sua senha.</p>
                    </div>
                    <div class="form-actions">
                        <button @click="$emit('close')" class="button btn-purple">
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { FORGOT_PASSWORD } from '../../services/user'

    export default {
        name: "forgot-password-modal",
        components: {  },
        data() {
            return {
                showRegisterModal: false,
                forgotPasswordUrl: "",
                showPassword: false,
                loading: false,
                form: {
                    email: null,
                    password: null,
                    remember: false,
                },
                confirmed: false,
                errors: [],
            }
        },
        methods: {
            clearErrors() {
                this.errors = [];
            },
            handleShowPassword() {
                this.showPassword = !this.showPassword;
                const password = document.getElementById('password');
                if(this.showPassword){
                    password.type = "text";
                }else{
                    password.type = "password";
                }
            },
            outsideClick() {
                if(event.target === event.currentTarget)
                    this.$emit('close');
            },
            async handleSubmit(event) {
                event.preventDefault();
                this.clearErrors();
                this.loading = true;
                FORGOT_PASSWORD(this.form).then(
                    resp => {
                        this.confirmed = true;
                    },
                    error => this.errors = error.response.data.errors,
                    ).then(
                        resp => {
                            this.loading = false;
                        }
                );
            },
        },
        mounted() {

        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ForgotPasswordModal/ForgotPasswordModal.vue